<template>
  <div class="total-prize">
    <div class="inner">
      <div class="total-prize__card">
        <div class="total-prize__card__label">
          <h4 class="total-prize__card__label__inner">
            <span class="total-prize__card__label__inner__text hidden-sp"
              >The Sauna Finance<br />Oropo Lotterly</span
            >
            <span class="total-prize__card__label__inner__text hidden-pc"
              >The Sauna Finance Oropo Lotterly</span
            >
            <img
              :src="`/assets/sf/image/target.png`"
              class="total-prize__card__label__inner__icon"
            />
          </h4>
        </div>
        <div class="total-prize__card__total">
          <h4
            class="total-prize__card__total__inner__text"
            v-if="totalPrize > 0"
          >
            $ {{ toCurrency(totalPrize) }}
          </h4>
          <h4 class="total-prize__card__total__inner__text --text-gray" v-else>
            $ {{ toCurrency(totalPrize) }}
          </h4>
        </div>
        <div class="total-prize__card__prize">
          <h4 class="total-prize__card__prize__inner">
            <span class="total-prize__card__prize__inner__text"
              >In Total Oropo prizes!</span
            >
            <img
              :src="`/assets/sf/image/beer.png`"
              class="total-prize__card__prize__inner__icon"
            />
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numFormat from "number-format.js";

export default {
  name: "LotteryCard",
  props: {
    totalPrize: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  methods: {
    toCurrency(num) {
      return numFormat("#,##0.00", num);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.total-prize {
  max-width: 1160px;
  margin-bottom: 24px;

  @include media(pc) {
    margin: 0 auto;
    margin-bottom: 54px;
  }

  &__card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: var(--color_bg_parts);
    border-radius: 20px;
    box-shadow: $box-shadow;
    padding: 32px 32px 24px;

    @include media(pc) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 32px 40px;
    }

    &__label__inner {
      font-size: 1.6rem;
      display: inline-block;
      margin-bottom: 10px;

      @include media(pc) {
        font-size: 2.5rem;
      }

      &__text {
        background: $gradation-vertical;
        background-clip: text;
        color: transparent;
        line-height: 1.5;
        margin-right: 5px;
      }

      &__icon {
        width: 20px;
        height: 20px;

        @include media(pc) {
          width: 40px;
          height: 40px;
          margin-top: -5px;
        }
      }
    }

    &__total {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;

      &__inner__text {
        font-size: 4.6rem;
        line-height: 1.5;
        font-weight: bold;
      }
    }

    &__prize {
      &__inner {
        display: flex;
        justify-content: center;
        align-items: center;

        &__text {
          font-size: 1.6rem;
          line-height: 1.5;
          margin-right: 5px;
          font-weight: bold;
          @include media(pc) {
            font-size: 1.7rem;
          }
        }

        &__icon {
          width: 40px;
          height: 40px;
          
          @include media(pc) {
            width: 80px;
            height: 80px;
          }
        }
      }
    }
  }
}
.hidden-sp {
  @include media(sp) {
    display: none;
  }
}
.hidden-pc {
  @include media(pc) {
    display: none;
  }
}
.--text-gray {
  color: $gray1;
}
</style>